import styled from "styled-components";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { fadeInUp, slideIn } from "./Animations.styles";

export const HistorySection = styled.div`
    background: rgba(255, 255, 255, 0.95);
    padding: 10px;
    border-radius: 8px;
    border: none;
    margin-bottom: 12px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
    animation: ${fadeInUp} 0.8s ease-out;
`;

export const HistoryTitleWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    margin-bottom: 8px;
    padding: 4px;
    border-radius: 2px;
    transition: background 0.2s;

    &:hover {
        background: rgba(156, 163, 175, 0.1);
    }
`;

export const TitleWithIcon = styled.div`
    display: flex;
    align-items: center;
    gap: 6px;

    svg {
        color: #4b5563;
        font-size: 16px;
    }
`;

export const HistoryToggleIcon = styled(ExpandMoreIcon)`
    color: #666666;
    font-size: 18px !important;
    transition: transform 0.3s ease;
    transform: ${(props) =>
        props.expanded ? "rotate(180deg)" : "rotate(0deg)"};
`;

export const HistoryItemsContainer = styled.div`
    max-height: ${(props) => (props.expanded ? "500px" : "0")};
    overflow-y: ${(props) => (props.expanded ? "auto" : "hidden")};
    transition: max-height 0.3s ease-out;
`;

export const HistoryItem = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 6px 8px;
    background: rgba(249, 250, 251, 0.8);
    border-radius: 2px;
    margin-bottom: 4px;
    transition: all 0.2s;
    animation: ${slideIn} 0.3s ease-out;

    &:hover {
        background: rgba(243, 244, 246, 1);
    }

    &:last-child {
        margin-bottom: 0;
    }
`;

export const HistoryItemLeft = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2px;
    flex: 1;
`;

export const HistoryItemJob = styled.div`
    font-family: "HelveticaW05Text", "Helvetica", sans-serif;
    font-size: 11px;
    color: #374151;
    font-weight: 500;
`;

export const HistoryItemDate = styled.div`
    font-family: "HelveticaW05Text", "Helvetica", sans-serif;
    font-size: 9px;
    color: #9ca3af;
`;

export const HistoryItemHours = styled.div`
    font-family: "HelveticaW05Text", "Helvetica", sans-serif;
    font-size: 12px;
    font-weight: 700;
    color: #6b7280;
`;

export const EmptyMessage = styled.div`
    font-family: "HelveticaW05Text", "Helvetica", sans-serif;
    font-size: 11px;
    color: #9ca3af;
    text-align: center;
    padding: 12px 8px;
    font-style: italic;
`;
